
import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, IconButton, TextField, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import XAPPButton from "../../../Core/Components/Button/XAPPButton";
import * as Actions from "../Store/Actions/EmpresaPessoaActions";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    paper: {
        border: "1px solid " + theme.palette.divider,
        //marginBottom: "24px",
        padding: "4px"
    },
    spanlabel: {
        top: 9,
        left: 15,
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        paddingRight: 5,
        paddingLeft: 5,
        fontSize: 12.5,
        fontFamily: "Muli,Roboto,\"Helvetica\",Arial,sans-serif",
        color: theme.palette.text.secondary,
        maxWidth: "60px",
    }
});

class EmpresaPessoaVincularDialog extends XAPPComponent {

    state = {
        open: false,
        login: "",
        idprojeto: ""
    };

    componentDidMount() {
        const { user } = this.props;
        this.setState(_.set({ ...this.state }, "idprojeto", user.idprojeto));
    }

    componentDidUpdate(prevProps, prevState) {
        const { form } = this.props;
        if (!prevState.open && this.state.open && form.formulario.uid != "-1") {
            this.setState(_.set({ ...this.state, "login": form.formulario.email, "uid": form.formulario.uid }));
        }

        if (!_.isNull(this.props.alterVinculo) && !_.isEqual(prevProps.alterVinculo, this.props.alterVinculo)) {
            this.afterChangeVinculo();
        }
    }

    afterChangeVinculo = () => {
        const { form, xappRouteParams, clearAlterVinculo, onChange, save, callback } = this.props;
        var AObj = { ...form };
        AObj.formulario.uid = -1;
        onChange(AObj.formulario);
        this.openDialog();
        clearAlterVinculo();
        save(AObj, xappRouteParams, callback);
    };

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value));
    };

    canBeSubmitted = () => {
        const { login } = this.state;
        return (!_.isUndefined(login) && !_.isNull(login) && login !== "");
    };

    openDialog = () => {
        this.setState(_.set({ ...this.state }, "open", !this.state.open));
    };

    render() {
        const { vincularUsuario, form, xappRouteParams } = this.props;
        const { open, login } = this.state;
        var AFlag = false;
        if (!_.isUndefined(form.formulario.uid) && !_.isNull(form.formulario.uid) && form.formulario.uid.length > 5) {
            AFlag = true;
        }

        return (
            <React.Fragment>
                <XAPPButton
                    type="Button"
                    className="bg-green hover:bg-green text-white mr-8"
                    variant="contained"
                    color="primary"
                    onClick={() => this.openDialog()}
                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                    icon={AFlag ? "minus" : "add"}
                    label={md.mobile() === null && md.tablet() === null ? (AFlag ? "Desvincular usuário" : "Vincular usuário") : ""}
                />
                <XAPPDialog
                    id="EmpresaPessoaVinculo"
                    open={open}
                    onClose={() => this.openDialog()}
                    fullWidth
                    maxWidth="sm"
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography className="text-white" color="action">
                                {AFlag ? "Desvincular usuário" : "Vincular usuário"}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <IconButton
                                key="close"
                                aria-label="Close"
                                className="p-6"
                                onClick={() => this.openDialog()}
                            >
                                <MdClose className="text-20 text-white" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent className="p-24">
                        {AFlag ?
                            <Typography variant="subtitle1" className="pb-16 leading-normal">
                                {"Tem certeza que deseja desvincular esse usuário, o colaborador perderá o acesso ao sistema."}
                            </Typography>
                            :
                            <React.Fragment>
                                <Typography variant="subtitle1" className="pb-16 leading-normal">
                                    {"Preencha o campo abaixo com o email informado pelo colaborador no momento do cadastro de conta disponível na tela de login do sistema."}
                                </Typography>
                                <TextField
                                    className="w-full"
                                    label="Email"
                                    id="login"
                                    name="login"
                                    value={login}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </React.Fragment>
                        }
                    </DialogContent>
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0">
                            <DialogActions>
                                {AFlag ?
                                    <XAPPButton
                                        type="Button"
                                        className="bg-red hover:bg-red text-white"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => vincularUsuario(this.state, xappRouteParams, "REMOVERFUNCIONARIO", form)}
                                        //disabled={!this.canBeSubmitted()}
                                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                        icon={"send"}
                                        label={md.mobile() === null && md.tablet() === null ? "Desvincular" : ""}
                                    />
                                    :
                                    <XAPPButton
                                        type="Button"
                                        className="bg-green hover:bg-green text-white"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => vincularUsuario(this.state, xappRouteParams, "INSERIRCHAVE", form)}
                                        disabled={!this.canBeSubmitted()}
                                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                        icon={"send"}
                                        label={md.mobile() === null && md.tablet() === null ? "Enviar" : ""}
                                    />
                                }
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                </XAPPDialog>
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        vincularUsuario: Actions.vincularUsuario,
        showMessage: AppActions.showMessage,
        clearAlterVinculo: Actions.clearAlterVinculo,
        save: Actions.save,
    }, dispatch);
}

function mapStateToProps({ Pessoa, auth }) {
    return {
        user: auth.user.data,
        Tags: Pessoa.TagFuncionalidadeReducer.data,
        alterVinculo: Pessoa.EmpresaPessoaReducer.alterVinculo,
    };
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaVincularDialog));
